// The Live Stream card opens the HCP viewer (clir-rj-cme-core) for the current session,
// logged in as the test HCP from .env (DEVLINK_*): the same login and link as
// cme-core's devconfig "User (HCP)" link - ?type=hcp&session_id=…&token=<refresh_token>.
import { buildLink, fetchLinkToken } from "../devconfig/userLink.js";

const env = import.meta.env;

export const VIEWER_ORIGIN = (env.VIEWER_ORIGIN || "https://clir-rj-cme-core.pages.dev").replace(/\/+$/, "");

export const VIEWER_LOGIN = {
  loginUrl: env.VIEWER_LOGIN_URL || "https://api.clirnet.com/auth/login",
  tokenField: "refresh_token",
  body: ({ email, password, deviceId }) => ({ deviceId, email, password }),
};

// Read at call time (not import time) so a rebuilt .env or a test stub is picked up.
function viewerCreds() {
  return {
    email: (env.DEVLINK_EMAIL || "").trim(),
    password: env.DEVLINK_PASSWORD || "",
    deviceId: env.DEVLINK_DEVICE_ID || "device-123-abc",
  };
}

export async function fetchViewerLink(sessionId, fetchImpl) {
  const creds = viewerCreds();
  if (!creds.email || !creds.password) {
    throw new Error("Viewer login is not set up (DEVLINK_EMAIL / DEVLINK_PASSWORD)");
  }
  const token = await fetchLinkToken(VIEWER_LOGIN, creds, fetchImpl);
  return buildLink({ origin: VIEWER_ORIGIN, type: "hcp", sessionId, token });
}

// The tab is opened synchronously, inside the click, so popup blockers allow it - after
// the login's await it would count as an unsolicited popup. It is pointed at the link once
// the login answers, or closed again if the login fails (the error is rethrown).
export async function openViewerTab(sessionId, { fetchImpl, openImpl = (...args) => window.open(...args) } = {}) {
  const tab = openImpl("", "_blank");
  // The viewer must not be able to reach back into the admin page.
  if (tab) tab.opener = null;
  try {
    const link = await fetchViewerLink(sessionId, fetchImpl);
    if (tab) tab.location.href = link;
    else openImpl(link, "_blank", "noopener");
    return link;
  } catch (e) {
    tab?.close();
    throw e;
  }
}
